app.directive('icfDemo', ['$stateParams', 'objectHelper', 'icdModel', 'userModel', 'dictionaryModel', 'icfDiagnosisModel',
    function ($stateParams, objectHelper, icdModel, userModel, dictionaryModel, icfDiagnosisModel) {
        var definition = {
            restrict: 'E',
            replace: true,
            require: '^form',
            scope: {
                data: '=',
                newIcf: '=', // fixme - I think it can be deleted
                icfDiagnosis: '=',
                visitCard: '='
            },
            templateUrl: 'edm/application/directive/icfDemo/template/icf-demo.html',
            link: function ($scope, element, attr, formCtrl) {
                $scope.form = formCtrl;
                $scope.doctorId = userModel.currentUser.id;

                // icf stuff @deprecated
                $scope.data = [];
                $scope.viewReady = false;
                $scope.allQualifierDictionariesLoaded = false;
                $scope.icfQualifierDictionaryLoaded = {
                    COMMON_ICF_FIRST_QUALIFIER: null,
                    E_ICF_FIRST_QUALIFIER: null,
                    D_ICF_SECOND_QUALIFIER: null,
                    S_ICF_SECOND_QUALIFIER: null,
                    S_ICF_THIRD_QUALIFIER: null
                };

                $scope.removeICF = function (diagnosis) {
                    _.remove($scope.data, function (element) {
                        var shouldRemove = (element === diagnosis);
                        if (shouldRemove) {
                            icfDiagnosisModel.delete(element.icfDiagnosis.id);
                        }
                        return shouldRemove;
                    });
                };

                /**
                 * @deprecated
                 * @param icfCode
                 * @returns {string|*}
                 */
                $scope.getIcfType = function (icfCode) {
                    return icfCode.substr(0, 1);
                };

                $scope.$watch('newIcf', function (newVal, oldVal) {
                    if (!_.isUndefined(newVal) && newVal != null) {
                        var newIcfDiagnosis = new ICFDiagnosisVO();
                        newIcfDiagnosis.icf = newVal;
                        loadQualifierDictionary(newIcfDiagnosis);
                        updateICFDiagnoses();
                        $scope.newIcf = undefined;
                    }
                });

                // icf
                $scope.$watch('icfQualifierDictionaryLoaded', function (newVal) {
                    if (!_.isUndefined(newVal) && newVal != null) {
                        $scope.allQualifierDictionariesLoaded = Object.keys($scope.icfQualifierDictionaryLoaded).every(function (key) {
                            return $scope.icfQualifierDictionaryLoaded[key] != null;
                        });

                        checkIfLoadedAndWrapIcfDiagnosis();
                    }
                }, true);


                function updateViewReference(changedDiagnosis, savedDiagnosis) {
                    var index = _.findIndex($scope.data, ['icfDiagnosis', changedDiagnosis]);
                    $scope.data[index].icfDiagnosis = savedDiagnosis;
                    console.log($scope.data[index]);
                }

                function updateDiagnosis(changedDiagnosis) {
                    if (!$scope.viewReady) {
                        return;
                    }
                    changedDiagnosis.visitCard = {
                        id: $scope.visitCard.id
                    };
                    if (changedDiagnosis.id != null && changedDiagnosis.firstQualifier != null) {
                        icfDiagnosisModel.update(changedDiagnosis).then(function (savedDiagnosis) {
                            //   updateViewReference(changedDiagnosis, savedDiagnosis);
                        });
                    } else {
                        icfDiagnosisModel.save(changedDiagnosis).then(function (savedDiagnosis) {
                            changedDiagnosis.id = savedDiagnosis.id;
                        });
                    }
                }

                $scope.firstQualifierChanged = function (changedDiagnosis) {
                    updateDiagnosis(changedDiagnosis);
                };

                $scope.secondQualifierChanged = function (changedDiagnosis) {
                    updateDiagnosis(changedDiagnosis);
                };

                $scope.thirdQualifierChanged = function (changedDiagnosis) {
                    updateDiagnosis(changedDiagnosis);
                };

                function updateICFDiagnoses() {
                    $scope.icfDiagnosis = [];
                    $scope.data.forEach(function (localICFDiagnosis) {
                        $scope.icfDiagnosis.push(localICFDiagnosis.icfDiagnosis);
                    });

                }

                /**
                 * @deprecated
                 */
                function checkIfLoadedAndWrapIcfDiagnosis() {
                    if ($scope.allQualifierDictionariesLoaded && $scope.visitCard) {
                        if ($scope.visitCard && $scope.visitCard.icfDiagnosis) {
                            $scope.visitCard.icfDiagnosis.forEach(function (icfDiagnosis) {
                                loadQualifierDictionary(icfDiagnosis);
                            });
                            $scope.viewReady = true;
                        }
                    }
                }


                /**
                 * @deprecated
                 * @param icf
                 */
                function loadQualifierDictionary(icf) {
                    var codeType = $scope.getIcfType(icf.icf.value);
                    switch (codeType) {
                        case 'b':
                            loadDictionary(icf, Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.COMMON);
                            break;

                        case 'e':
                            loadDictionary(icf, Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.E);
                            break;

                        case 'd':
                            loadDictionary(icf, Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.D);
                            break;

                        case 's':
                            loadDictionary(icf, Constant.DICTIONARY_CODE.ICF_THIRD_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.S);
                            break;
                    }
                }

                function onGetDictionaryElementsDataPage(dataPage, code, additionalCriteriaField) {
                    if (code === Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER && additionalCriteriaField === Constant.ICF_QUALIFIER_TYPE.COMMON) {
                        $scope.icfQualifierDictionaryLoaded.COMMON_ICF_FIRST_QUALIFIER = dataPage.data;
                    }
                    if (code === Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER && additionalCriteriaField === Constant.ICF_QUALIFIER_TYPE.E) {
                        $scope.icfQualifierDictionaryLoaded.E_ICF_FIRST_QUALIFIER = dataPage.data;
                    }
                    if (code === Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER && additionalCriteriaField === Constant.ICF_QUALIFIER_TYPE.D) {
                        $scope.icfQualifierDictionaryLoaded.D_ICF_SECOND_QUALIFIER = dataPage.data;
                    }
                    if (code === Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER && additionalCriteriaField === Constant.ICF_QUALIFIER_TYPE.S) {
                        $scope.icfQualifierDictionaryLoaded.S_ICF_SECOND_QUALIFIER = dataPage.data;
                    }
                    if (code === Constant.DICTIONARY_CODE.ICF_THIRD_QUALIFIER && additionalCriteriaField === Constant.ICF_QUALIFIER_TYPE.S) {
                        $scope.icfQualifierDictionaryLoaded.S_ICF_THIRD_QUALIFIER = dataPage.data;
                    }
                }

                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, {additionalCriteriaField: Constant.ICF_QUALIFIER_TYPE.COMMON}).then(function (dataPage) {
                    onGetDictionaryElementsDataPage(dataPage, Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.COMMON);
                });
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, {additionalCriteriaField: Constant.ICF_QUALIFIER_TYPE.E}).then(function (dataPage) {
                    onGetDictionaryElementsDataPage(dataPage, Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.E);
                });
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER, {additionalCriteriaField: Constant.ICF_QUALIFIER_TYPE.D}).then(function (dataPage) {
                    onGetDictionaryElementsDataPage(dataPage, Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.D);
                });
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER, {additionalCriteriaField: Constant.ICF_QUALIFIER_TYPE.S}).then(function (dataPage) {
                    onGetDictionaryElementsDataPage(dataPage, Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.S);
                });
                dictionaryModel.getDictionaryElementsDataPage(Constant.DICTIONARY_CODE.ICF_THIRD_QUALIFIER, {additionalCriteriaField: Constant.ICF_QUALIFIER_TYPE.S}).then(function (dataPage) {
                    onGetDictionaryElementsDataPage(dataPage, Constant.DICTIONARY_CODE.ICF_THIRD_QUALIFIER, Constant.ICF_QUALIFIER_TYPE.S);
                });

                /**
                 * @deprecated
                 * @param icf
                 * @param code
                 * @param icfQualifierType
                 */
                function loadDictionary(icf, code, icfQualifierType) {
                    var localIcfDiagnosis = {
                        icfDiagnosis: icf,
                        firstQualifierDictionary: null,
                        secondQualifierDictionary: null,
                        thirdQualifierDictionary: null
                    };

                    localIcfDiagnosis.firstQualifierDictionary = $scope.icfQualifierDictionaryLoaded.COMMON_ICF_FIRST_QUALIFIER;

                    if (code === Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER && icfQualifierType === Constant.ICF_QUALIFIER_TYPE.COMMON) {
                        localIcfDiagnosis.firstQualifierDictionary = $scope.icfQualifierDictionaryLoaded.COMMON_ICF_FIRST_QUALIFIER;
                    }

                    if (code === Constant.DICTIONARY_CODE.ICF_FIRST_QUALIFIER && icfQualifierType === Constant.ICF_QUALIFIER_TYPE.E) {
                        localIcfDiagnosis.firstQualifierDictionary = $scope.icfQualifierDictionaryLoaded.E_ICF_FIRST_QUALIFIER;
                    }

                    if (code === Constant.DICTIONARY_CODE.ICF_SECOND_QUALIFIER && icfQualifierType === Constant.ICF_QUALIFIER_TYPE.D) {
                        localIcfDiagnosis.secondQualifierDictionary = $scope.icfQualifierDictionaryLoaded.D_ICF_SECOND_QUALIFIER;
                    }

                    if (code === Constant.DICTIONARY_CODE.ICF_THIRD_QUALIFIER && icfQualifierType === Constant.ICF_QUALIFIER_TYPE.S) {
                        localIcfDiagnosis.secondQualifierDictionary = $scope.icfQualifierDictionaryLoaded.S_ICF_SECOND_QUALIFIER;
                        localIcfDiagnosis.thirdQualifierDictionary = $scope.icfQualifierDictionaryLoaded.S_ICF_THIRD_QUALIFIER;
                    }

                    if (localIcfDiagnosis.icfDiagnosis.firstQualifier) {
                        localIcfDiagnosis.icfDiagnosis.firstQualifier = _.find(localIcfDiagnosis.firstQualifierDictionary, function (q) {
                            return q.id === localIcfDiagnosis.icfDiagnosis.firstQualifier.id;
                        });
                    }

                    if (localIcfDiagnosis.icfDiagnosis.secondQualifier) {
                        localIcfDiagnosis.icfDiagnosis.secondQualifier = _.find(localIcfDiagnosis.secondQualifierDictionary, function (q) {
                            return q.id === localIcfDiagnosis.icfDiagnosis.secondQualifier.id;
                        });
                    }

                    if (localIcfDiagnosis.icfDiagnosis.thirdQualifier) {
                        localIcfDiagnosis.icfDiagnosis.thirdQualifier = _.find(localIcfDiagnosis.thirdQualifierDictionary, function (q) {
                            return q.id === localIcfDiagnosis.icfDiagnosis.thirdQualifier.id;
                        });
                    }

                    $scope.data.push(localIcfDiagnosis);
                }

            }
        };

        return definition;
    }
]);